import isValidEmail from "./isValidEmail"

export type EmailValidationResponseType = "not-single" | "incorrect" | "success"

export enum emailValidationResponse {
  NOT_SINGLE = "not-single",
  INCORRECT = "incorrect",
  SUCCESS = "success",
}

const isEmailValidAndSingle = (email: string): EmailValidationResponseType => {
  if (!isValidEmail(email)) {
    return emailValidationResponse.INCORRECT
  }

  const re: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  if (!re.test(email)) {
    return emailValidationResponse.NOT_SINGLE
  }

  return emailValidationResponse.SUCCESS
}

export default isEmailValidAndSingle
